"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyInfoEditForm = CompanyInfoEditForm;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const uuid = __importStar(require("uuid"));
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const types_1 = require("@src/types");
const get_cdn_image_url_1 = require("@shared/get-cdn-image-url");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
const form_fields_1 = require("./form-fields");
const companyInfoEditFormRules_1 = require("./companyInfoEditFormRules");
const CompanyInfoEditForm_style_1 = require("./CompanyInfoEditForm.style");
function getImageThumb(pictureUrl) {
    return (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: `web/company/${pictureUrl}`,
        transformation: 'w_140,h_140,c_limit',
    });
}
function CompanyInfoEditForm() {
    const [form] = antd_1.Form.useForm();
    const { companyInfo: company } = (0, admin_context_1.useAdminContextValue)();
    const [loading, setLoading] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const queryClient = (0, react_query_1.useQueryClient)();
    // @ts-ignore
    const rules = (0, companyInfoEditFormRules_1.companyInfoEditFormRules)(intl, company);
    const [imageFile, setImageFile] = react_1.default.useState([]);
    const [titleFile, setTitleFile] = react_1.default.useState([]);
    const { companyNameRules, descriptionRules, socialLinkRules } = rules;
    const initialValues = react_1.default.useMemo(() => {
        var _a, _b, _c, _d;
        return ({
            ...company,
            [types_1.CompanyInfoEditFormField.street_address]: (_a = company.address) === null || _a === void 0 ? void 0 : _a.street_address,
            [types_1.CompanyInfoEditFormField.city]: (_b = company.address) === null || _b === void 0 ? void 0 : _b.city,
            [types_1.CompanyInfoEditFormField.postal_code]: (_c = company.address) === null || _c === void 0 ? void 0 : _c.postal_code,
            [types_1.CompanyInfoEditFormField.country]: (_d = company.address) === null || _d === void 0 ? void 0 : _d.country,
            [types_1.CompanyInfoEditFormField.facebook_url]: company.facebook_url,
            [types_1.CompanyInfoEditFormField.instagram_url]: company.instagram_url,
            [types_1.CompanyInfoEditFormField.twitter_url]: company.twitter_url,
            [types_1.CompanyInfoEditFormField.linkedin_url]: company.linkedin_url,
            [types_1.CompanyInfoEditFormField.youtube_url]: company.youtube_url,
            [types_1.CompanyInfoEditFormField.description]: company.description,
        });
    }, [company]);
    const init = () => {
        const { image } = company;
        const titleImage = company.titleImageUrl;
        if (image) {
            const imageThumb = getImageThumb(image);
            setImageFile([{ thumbUrl: imageThumb, uid: uuid.v4() }]);
        }
        if (titleImage) {
            const titleImageThumb = getImageThumb(titleImage);
            setTitleFile([{ thumbUrl: titleImageThumb, uid: uuid.v4() }]);
        }
    };
    react_1.default.useEffect(() => {
        init();
    }, []);
    const onSubmit = async (values) => {
        var _a, _b;
        try {
            setLoading(true);
            await Api.Company.setCompanyInfo(values);
            if (initialValues.title_image_url && (titleFile === null || titleFile === void 0 ? void 0 : titleFile.length) === 0) {
                await Api.Company.deleteCompanyImage('titleImageUrl');
            }
            if (initialValues.image && (imageFile === null || imageFile === void 0 ? void 0 : imageFile.length) === 0) {
                await Api.Company.deleteCompanyImage('image');
            }
            if ((imageFile === null || imageFile === void 0 ? void 0 : imageFile.length) === 1 || (titleFile === null || titleFile === void 0 ? void 0 : titleFile.length) === 1) {
                await Api.Company.setCompanyImages((_a = imageFile[0]) === null || _a === void 0 ? void 0 : _a.originFileObj, (_b = titleFile[0]) === null || _b === void 0 ? void 0 : _b.originFileObj);
            }
            queryClient.invalidateQueries(queries_1.Queries.getCompany);
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'general.warning',
                }),
                description: intl.formatMessage({
                    id: 'general.successfuly_saved',
                }),
            });
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        }
        finally {
            setLoading(false);
        }
    };
    if (!company) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, { form: form, layout: "vertical", scrollToFirstError: { behavior: 'smooth', block: 'center' }, onFinish: onSubmit, initialValues: initialValues, children: [(0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(elements_1.Alert, { message: intl.formatMessage({
                            id: 'registration.registration_form.alert',
                        }, {
                            a: chunks => (0, jsx_runtime_1.jsx)(elements_1.Link, { to: `/firma/${company.company_url}`, children: chunks }),
                        }), showIcon: true, type: "info", className: "m-b-l form_alert", banner: true }) }), (0, jsx_runtime_1.jsx)(form_fields_1.UploadFields, { intl: intl, image: imageFile, setImage: setImageFile, titleImage: titleFile, setTitleImage: setTitleFile }), (0, jsx_runtime_1.jsx)(antd_1.Row, { gutter: [16, 16], children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                                id: 'admin.company_info_edit_form.emplyer_name',
                            }), name: types_1.CompanyInfoEditFormField.name, rules: companyNameRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }) }) }), (0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 16], children: [(0, jsx_runtime_1.jsx)(form_fields_1.AddressFields, { intl: intl, rules: rules }), (0, jsx_runtime_1.jsx)(form_fields_1.CinTinFields, { intl: intl, rules: rules })] }), (0, jsx_runtime_1.jsx)(antd_1.Row, { gutter: [16, 16], children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                                id: 'admin.company_info_edit_form.about_company',
                            }), name: types_1.CompanyInfoEditFormField.description, rules: descriptionRules, children: (0, jsx_runtime_1.jsx)(elements_1.RichText.RichTextEditorAnt, {}) }) }) }), (0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 16], children: [(0, jsx_runtime_1.jsx)(form_fields_1.SocialLinksFields, { intl: intl, setFieldsValue: form.setFieldsValue, socialLinkRule: socialLinkRules }), (0, jsx_runtime_1.jsx)(form_fields_1.CompanyCloserInformationsFields, { intl: intl, rules: rules })] }), (0, jsx_runtime_1.jsx)(CompanyInfoEditForm_style_1.SubmitButtonWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Button, { htmlType: "submit", type: "primary", size: "large", loading: loading, children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-xxs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.company_info_edit_form.save_changes" }) }) }) }), (0, jsx_runtime_1.jsxs)(CompanyInfoEditForm_style_1.RequiredWrapper, { children: [(0, jsx_runtime_1.jsx)(CompanyInfoEditForm_style_1.RedText, { children: "*" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.company_info_edit_form.mandatory_fields" })] })] }) }));
}
